import React from 'react';
import { motion } from 'motion/react';
import './Logo.css';

export function Logo({ className = "" }: { className?: string }) {
  return (
    <motion.div 
      className={`based-logo ${className}`}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="based-logo-mark">
        <motion.svg 
          width="35" 
          height="35" 
          viewBox="0 0 35 35" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {/* Top right dot - appears first */}
          <motion.path 
            d="M32.5 5C33.8807 5 35 3.88071 35 2.5C35 1.11929 33.8807 0 32.5 0C31.1193 0 30 1.11929 30 2.5C30 3.88071 31.1193 5 32.5 5Z" 
            fill="#1E3A8A"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.1, type: "spring" }}
          />
          
          {/* Orange piece - slides in from left */}
          <motion.path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M4.43981 7L0 10.1281L9.65312 24C9.44228 22.2652 9.57507 20.4595 10.103 18.6778C10.3371 17.887 10.6385 17.1355 11 16.427L4.43981 7Z" 
            fill="#FFB400" 
            fillOpacity="0.8"
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
          />
          
          {/* Blue piece 1 - slides in from right */}
          <motion.path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M12.2613 7L8 10.1663L11.1892 15C12.1983 13.4251 13.505 12.1212 15 11.1514L12.2613 7Z" 
            fill="#1E3A8A" 
            fillOpacity="0.3"
            initial={{ x: 20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
          />
          
          {/* Blue piece 2 - slides in from top */}
          <motion.path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M16.3701 0L12 2.89984L17.246 10C19.0266 9.25209 20.9925 8.88533 23 8.97339L16.3701 0Z" 
            fill="#1E3A8A"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
          />
          
          {/* Main complex piece - grows from center */}
          <motion.path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M25.0584 10.2673C18.7599 8.94256 12.3944 12.6529 10.5238 18.9312C9.99421 20.7081 9.87844 22.5101 10.1212 24.2338L21.7208 21.4692L25.0584 10.2673ZM22.1796 23.5011L10.5827 26.2653C11.7914 30.0794 14.8075 33.2471 18.9309 34.4762C23.0473 35.7031 27.2978 34.7082 30.3959 32.1875L22.1796 23.5011ZM34.4764 26.0691C33.9447 27.8534 33.0496 29.4303 31.8967 30.743L23.7093 22.0877L27.0545 10.8621C33.0507 13.2011 36.347 19.7904 34.4764 26.0691Z" 
            fill="#1E3A8A" 
            fillOpacity="0.8"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5, type: "spring", stiffness: 200 }}
          />
        </motion.svg>
        
        <motion.div
          className="based-logo-glow"
          style={{
            background: "radial-gradient(circle, rgba(30, 58, 138, 0.1) 0%, transparent 70%)",
          }}
          initial={{ opacity: 0 }}
          whileHover={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        />
      </div>
      
      <div className="based-logo-text">
        <motion.span 
          className="based-logo-text-strong"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
        >
          Based
        </motion.span>
        <motion.span 
          className="based-logo-text-soft"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.7 }}
        >
          On
        </motion.span>
      </div>
    </motion.div>
  );
}
